import { Component, OnInit } from '@angular/core';
import {Dashboard} from '../models/Dashboard';
import {DashboardService} from './dashboard.service';
import {MatTableDataSource} from '@angular/material/table';
import {Contract} from '../models/Contract';
import {Invoice} from '../models/Invoice';
import {Router} from '@angular/router';
import {OpenMovement} from '../models/OpenMovement';
import {InvoiceNew} from '../models/InvoiceNew';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public clientName: string = "";
  public dashboardStatus: Dashboard = {} as Dashboard;
  public dataSourceContracts: MatTableDataSource<Contract> = new MatTableDataSource<Contract>();
  public datasourceMovements: MatTableDataSource<InvoiceNew> = new MatTableDataSource<InvoiceNew>();
  public displayedColumnsContracts: Array<string>;
  public displayedColumnsMovements: Array<string>;

  constructor(
    private service: DashboardService,
    private router: Router,
  ) {
    this.displayedColumnsContracts = [
      'GEN_CONTRATO',
      'DESCRICAO',
      'DESCRICAO_LOJA',
      'VALOR_BASE',
      'DATA_LOCACAO',
      'FINALIZAR_CONTRATO_DATA',
      'INADIMPLENCIA',
    ];
    this.displayedColumnsMovements = [
      'DESCRICAO_LOJA_CONTRATO',
      'MES_REFERENCIA',
      // 'DESCRICAO_FATURA',
      'DATA_EMISSAO',
      'DATA_VENCIMENTO',
      'VALOR_TOTAL',
    ];
  }

  ngOnInit(): void {
    this.getDashboardStatus();
  }

  /**
   * Recupera os dados do dashboard
   */
  getDashboardStatus(): void {
      this.service.showSpinner();
      this.service.getStatistics().subscribe(data => {
          this.dashboardStatus = data;
          this.dataSourceContracts = new MatTableDataSource<Contract>(data.CONTRATOS);
          this.datasourceMovements = new MatTableDataSource<InvoiceNew>(data.MOVIMENTACOES);
          this.clientName = data.NOME;
          if (data.INADIMPLENTE){
              this.service.toasterWarning('Parece que você tem alguns débitos em aberto. Em caso de dúvidas, procure nosso setor financeiro.', 'Aviso importante');
          }
          this.service.hideSpinner();
      }, error => {
          console.error(error);
          this.service.hideSpinner();
          this.service.toasterError(error.error);
      });
  }

  /**
   * Aplica o filtro de contrato
   */
  applyFilterContract(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceContracts.filter = filterValue.trim().toLowerCase();
  }

  /**
   * Aplica o filtro de boletos
   */
  applyFilterInvoice(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.datasourceMovements.filter = filterValue.trim().toLowerCase();
  }

  /**
   *
   */
  openMovement(id: string): void {
    this.router.navigate(['principal/faturas/' + id]);
    // this.router.navigate(['principal/meus-debitos/']);
  }

  /**
   * Abrir contrato
   */
  openContract(id: string): void {
    this.router.navigate(['principal/contrato/' + id]);
  }
}
